import { ursaColors } from "@smartsheet/design-tokens";
import React, { CSSProperties, forwardRef, Ref } from "react";
import { GeneratedIconProps } from "../../icon/GeneratedIconProps";
import { Icon } from "../../icon/Icon";
import SignalBarsIcon20 from "./SignalBarsIcon20";

export interface SignalBarsIconProps extends GeneratedIconProps {
    /**
     * The size to render the icon at.
     */
    size: 20;
    /** Automatically fill the bars based on value. */
    value: 0 | 1 | 2 | 3 | 4;
}

export const SignalBarsIcon = forwardRef(
    ({ color = ursaColors.azure400, size, style, value, ...rest }: SignalBarsIconProps, ref: Ref<HTMLElement>) => (
        <Icon
            color={color}
            ref={ref}
            size={size}
            {...rest}
            style={
                {
                    ...style,
                } as CSSProperties
            }
        >
            <SignalBarsIcon20 value={value} />
        </Icon>
    )
);
SignalBarsIcon.displayName = "SignalBarsIcon";
